import {TypeMontant} from './TypeMontant';
import {TypeObjCPV} from './TypeObjCPV';
export class Lot {

	public estimationValeur: TypeMontant;

	public numLot: string;

	public description: string;

	public codeCPV: TypeObjCPV;

	public lieuExecutionLivraison: string;

	constructor() {
		this.estimationValeur = new TypeMontant();
		this.numLot = '';
		this.description = '';
		this.codeCPV = new TypeObjCPV();
		this.lieuExecutionLivraison = '';
	}
}
